import controller from './upload-classic-block.controller';
import template from './upload-classic-block.html';

export default {
	controller,
	template,
	bindings: {
		index:     '<',
		file:      '<ngModel',
		files:     '=',
		form:      '=',
		options:   '<?',
	},
	require:  {
		ngModelCtrl: '?ngModel',
	},
};
